document.querySelectorAll(".quick-product__btn-custom").forEach((button) => {
    button.addEventListener("click", function () {
        let formData = {
         'items': [{
          'id': this.getAttribute("data-variant-id"),
          'quantity': 1
          }]
        };
        console.log(this.getAttribute("data-variant-id"));
      
        fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
            .then((response) => {
                  console.log(response.json());
                  debugger;
              window.location.href = '/cart';
            })
            .catch((error) => {
                console.error("Error:", error);
            });

      // End of fetch
    });
});
